const modules = {
	title: "Moduler",
	stitle: "Modul",
	extra_title: "Ekstra moduler",
	new_module: "Ny Modul",
	edit_module: "Endre Modul: {name}",
	list_title: "Liste over moduler",
	id: "ID",
	tenant_id: "Klienter",
	name: "Navn",
	active_from: "Aktive fra",
	inactive_from: "Inaktive fra",
	status: "Status",
	price: "Pris",
	activated_by: "Aktivert av",
	activated_date: "Aktivert dato",
	add_module: "Legg til modul",
	update_module: "Oppdatert modul",
};
export default modules;